module.exports = {
  "en-US": "English",
  es: "Español",
  fr: "Francés",
  ht: "Kreyol",
  switch_es: "En español",
  "switch_en-US": "In english",
  switch_fr: "En français",
  switch_ht: "Nan kreyol",
  back: "Back",
  continue: "Continue",
  step: "Step",
  yes: "Yes",
  no: "No",
  nonpay: "Nonpayment",
  holdover: "Holdover",
  general: "I’m not sure",
  other: "Other",
  submit: "Submit",
  gotit: "Got it",
  addrPlaceholder: "Enter your address here",
  nychaPlaceholder: "Please select your development",
  addrError: "Sorry! Your address was not found. Please try again.",
  zipTitle: "Your zipcode",
  householdSize: "Household Size",
  income: "Annual Income",
  qualifiedTitle: "Great news! You likely have the right to a free attorney.",
  notQualifiedTitle:
    "You may not yet have the right to a free attorney, but you still have options to get assistance!",
  doNow: "Here's what you should do now:",
  additionalResources: "Additional Resources:",
  attribution:
    'This resource is made for tenants across NYC and is maintained by the <a href="https://www.righttocounselnyc.org/" target="_blank">Right to Counsel NYC Coalition</a>.<br /><br /><a href="https://docs.google.com/forms/d/e/1FAIpQLSfovU5BDMZHaX-EKQmSyVyKdrPvp9y0VuIBx_NlMQHB0NkNng/viewform?usp=sf_link" target="_blank">Click here</a> to provide feedback about the website.',
  justfixAttribution: "Made with ♥ by the team at",
  print: "Print",
  getInvolvedTitle: "Get involved with the Right to Counsel movement!",
  shareTitle: "Share this page with your neighbors:",
  email: "Email",
  registrationTitle: "Receive email updates:",
  registrationBtn: "Register with email",
  eventsTitle: "Attend upcoming events:",
  eventsBtn: "Find an event",
  saveToPhoneTitle: "Save this page to your Phone",
  saveToPhoneSubtitle:
    "Enter your phone number and we'll text you a link to bookmark this page.",
  saveToPhoneInfo:
    "The number should start with +1. <b>Your phone number will never be saved or used outside of this message.</b>",
  success: "Success",
  tryAgain: "Try Again",
  connectLSP: "Connect with an attorney before your court date:",
  next: "Next",
  more: "View more",
  prev: "Previous",
  website: "Website",
  evictionFreeNYC: "Eviction Free NYC",
  textMessageContent: "Follow this link for assistance in your eviction case",
  groupsTitle: "Fight your eviction by contacting a local community group",
  groupsLookMore: "Looking for more? Search the Tenant Assistance Directory",
  groupsEmpty:
    "There are no tenant organizing groups currently working in your area.",
  groupsEmptySubtitle:
    "Search the Tenant Assistance Directory for other support.",
  groupsSearch: "Enter your zipcode to find a local community group!",
  titleOverride:
    "If the head of household in your apartment is 62 years or older, and you have an administrative hearing at NYCHA, you have the right to an attorney. Otherwise, you still have options to get assistance.",
};



// WEBPACK FOOTER //
// ./src/data/messages/en-US.js